<template>
    <div class="animated fadeIn">
        <Request
                ref="requestWidget"
                :onRequestSuccess="onRequestSuccess"
                root="/dashboard/widget">
            <slot slot="body">

                <b-row>
                    <b-col v-if="Core.Session.AuthUser.can('dashboard_my_next_events_list')" lg="6">
                        <DynamicCardList
                                ref="dynamicCardListMyNextEvents"
                                caption="Mes événements"
                                :columns="[
                                    {
                                        label: Core.Definition.getDefinition('Début'),
                                        key: 'eventDateStart',
                                        sortable: true,
                                        type: Core.Value.typeDate,
                                        format: 'DD MMM YYYY HH:mm'
                                    },
                                    {
                                        label: Core.Definition.getDefinition('Titre'),
                                        key: 'eventDateTitle',
                                        sortable: true
                                    }
                                ]"
                                root="/dashboard/my-next-events-list">
                        </DynamicCardList>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col v-if="Core.Session.AuthUser.can('dashboard_payments')" lg="6">
                        <b-row class="mt-3 mb-2">
                            <b-col>
                                <h5 class="">{{Core.Definition.getDefinition('Paiements')}}</h5>
                            </b-col>
                        </b-row>
                        <b-card-group>
                            <CardChartLineSmall
                                    :chart="{
                                            labels: dataWidget.payments.completed.labels,
                                             sets:[
                                                  {
                                                    label: Core.Definition.getDefinition('Nouvelles inscriptions'),
                                                    backgroundColor: 'transparent',
                                                            borderColor: 'rgba(50,50,50,.8)',
                                                            data: dataWidget.payments.completed.data
                                                          }
                                                        ]
                                                }"
                                    :caption="Core.Definition.getDefinition('Paiements complétés')"
                                    :value="Core.Currency.format(dataWidget.payments.completed.value)">
                                <slot slot="body">
                                    <div class="h5 mb-3 text-right"></div>
                                </slot>
                            </CardChartLineSmall>
                            <b-card>
                                <div class="h5 mb-5 text-right"></div>
                                <div class="h4 mb-0">{{Core.Currency.format(dataWidget.payments.due.value)}} <small>({{dataWidget.payments.due.progressValue}}%)</small></div>
                                <small class="text-uppercase font-weight-bold">{{Core.Definition.getDefinition('Paiements dûs')}}</small>
                                <b-progress height={} class="progress-xs mt-3 mb-0 bg-success" variant="warning" :value="dataWidget.payments.due.progressValue"/>
                            </b-card>
                        </b-card-group>
                        <b-card-group>
                            <b-card>
                                <div class="h5 mb-5 text-right"></div>
                                <div class="h4 mb-0">{{Core.Currency.format(dataWidget.payments.waiting.value)}} <small>({{dataWidget.payments.waiting.progressValue}}%)</small></div>
                                <small class="text-uppercase font-weight-bold">{{Core.Definition.getDefinition('Paiements en attentes')}}</small>
                                <b-progress height={} class="progress-xs mt-3 mb-0 bg-success" variant="warning" :value="dataWidget.payments.waiting.progressValue"/>
                            </b-card>
                            <b-card>
                                <div class="h5 mb-5 text-right"></div>
                                <div class="h4 mb-0">{{Core.Currency.format(dataWidget.payments.failed.value)}} <small>({{dataWidget.payments.failed.progressValue}}%)</small></div>
                                <small class="text-uppercase font-weight-bold">{{Core.Definition.getDefinition('Paiements échoués')}}</small>
                                <b-progress height={} class="progress-xs mt-3 mb-0 bg-success" variant="danger" :value="dataWidget.payments.failed.progressValue"/>
                            </b-card>
                        </b-card-group>
                    </b-col>
                    <b-col v-if="Core.Session.AuthUser.can('dashboard_subscriptions')"  lg="6">
                        <b-row class="mt-3 mb-2">
                            <b-col>
                                <h5 class="">{{Core.Definition.getDefinition('Abonnements')}}</h5>
                            </b-col>
                        </b-row>
                        <b-card-group>
                            <CardChartLineSmall
                                    :chart="{
                                            labels: dataWidget.subscriptions.activated.labels,
                                             sets:[
                                                  {
                                                    label: Core.Definition.getDefinition('Nouvelles inscriptions'),
                                                    backgroundColor: 'transparent',
                                                            borderColor: 'rgba(0,0,0,.8)',
                                                            data: dataWidget.subscriptions.activated.data
                                                          }
                                                        ]
                                                }"
                                    :caption="Core.Definition.getDefinition('Abonnements actifs')"
                                    :value="dataWidget.subscriptions.activated.value">
                                <slot slot="body">
                                    <div class="h5 mb-3 text-right"></div>
                                </slot>
                            </CardChartLineSmall>
                            <b-card>
                                <div class="h5 mb-5 text-right"></div>
                                <div class="h4 mb-0">{{dataWidget.subscriptions.renewed.value}} <small>({{dataWidget.subscriptions.renewed.progressValue}}%)</small></div>
                                <small class="text-uppercase font-weight-bold">{{Core.Definition.getDefinition('Abonnements renouvellés')}}</small>
                                <b-progress height={} class="progress-xs mt-3 mb-0 bg-warning" variant="success" :value="dataWidget.subscriptions.renewed.progressValue"/>
                            </b-card>
                        </b-card-group>
                        <b-card-group>
                            <b-card>
                                <div class="h5 mb-5 text-right"></div>
                                <div class="h4 mb-0">{{dataWidget.subscriptions.expiration.value}} <small>({{dataWidget.subscriptions.expiration.progressValue}}%)</small></div>
                                <small class="text-uppercase font-weight-bold">{{Core.Definition.getDefinition('Abonnements bientôt terminés')}}</small>
                                <b-progress height={} class="progress-xs mt-3 mb-0 bg-success" variant="warning" :value="dataWidget.subscriptions.expiration.progressValue"/>
                            </b-card>
                            <b-card>
                                <div class="h5 mb-5 text-right"></div>
                                <div class="h4 mb-0">{{dataWidget.subscriptions.completed.value}}</div>
                                <small class="text-uppercase font-weight-bold">{{Core.Definition.getDefinition('Abonnements terminés')}}</small>
                            </b-card>
                        </b-card-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col v-if="false" lg="6">
                        <b-row class="mt-5 mb-2">
                            <b-col>
                                <h5 class="">{{Core.Definition.getDefinition('Essais gratuits')}}</h5>
                            </b-col>
                        </b-row>
                        <b-card-group>
                            <CardChartLineSmall
                                    :chart="{
                                            labels: dataWidget.labels,
                                             sets:[
                                                  {
                                                    label: Core.Definition.getDefinition('Nouvelles inscriptions'),
                                                    backgroundColor: 'transparent',
                                                            borderColor: 'rgba(0,0,0,.8)',
                                                            data: dataWidget.data
                                                          }
                                                        ]
                                                }"
                                    :caption="Core.Definition.getDefinition('Essais gratuits')"
                                    :value="dataWidget.count">
                                <slot slot="body">
                                    <div class="h5 mb-3 text-right">385 <i class="fa fa-long-arrow-up"></i></div>
                                </slot>
                            </CardChartLineSmall>
                            <b-card>
                                <div class="h5 mb-5 text-right">10% <i class="fa fa-long-arrow-up"></i></div>
                                <div class="h4 mb-0">50%</div>
                                <small class="text-uppercase font-weight-bold">{{Core.Definition.getDefinition('Conversion')}}</small>
                                <b-progress height={} class="progress-xs mt-3 mb-0" variant="info" :value="25"/>
                            </b-card>
                        </b-card-group>
                    </b-col>
                    <b-col v-if="Core.Session.AuthUser.can('dashboard_events')" lg="6">
                        <b-row class="mt-5 mb-2">
                            <b-col>
                                <h5 class="">{{Core.Definition.getDefinition('Événements')}}</h5>
                            </b-col>
                        </b-row>
                        <b-card-group>
                            <CardChartLineSmall
                                    :chart="{
                                            labels: dataWidget.events.booking.labels,
                                             sets:[
                                                  {
                                                    label: Core.Definition.getDefinition('Nouvelles inscriptions'),
                                                    backgroundColor: 'transparent',
                                                            borderColor: 'rgba(0,0,0,.8)',
                                                            data: dataWidget.events.booking.data
                                                          }
                                                        ]
                                                }"
                                    :caption="Core.Definition.getDefinition('Réservations')"
                                    :value="dataWidget.events.booking.value">
                                <slot slot="body">
                                    <div class="h5 mb-3 text-right"></div>
                                </slot>
                            </CardChartLineSmall>
                            <b-card>
                                <div class="h5 mb-5 text-right"></div>
                                <div class="h4 mb-0">{{dataWidget.events.present.value}} <small>({{dataWidget.events.present.progressValue}}%)</small></div>
                                <small class="text-uppercase font-weight-bold">{{Core.Definition.getDefinition('Présences')}}</small>
                                <b-progress height={} class="progress-xs mt-3 mb-0 bg-warning" variant="success" :value="dataWidget.events.present.progressValue"/>
                            </b-card>
                        </b-card-group>
                        <b-card-group>
                            <b-card>
                                <div class="h5 mb-5 text-right"></div>
                                <div class="h4 mb-0">{{dataWidget.events.absent.value}} <small>({{dataWidget.events.absent.progressValue}}%)</small></div>
                                <small class="text-uppercase font-weight-bold">{{Core.Definition.getDefinition('Absences')}}</small>
                                <b-progress height={} class="progress-xs mt-3 mb-0 bg-success" variant="warning" :value="dataWidget.events.absent.progressValue"/>
                            </b-card>
                            <b-card>
                                <div class="h5 mb-5 text-right"></div>
                                <div class="h4 mb-0">{{dataWidget.events.cancelled.value}} <small>({{dataWidget.events.cancelled.progressValue}}%)</small></div>
                                <small class="text-uppercase font-weight-bold">{{Core.Definition.getDefinition('Annulations')}}</small>
                                <b-progress height={} class="progress-xs mt-3 mb-0 bg-success" variant="danger" :value="dataWidget.events.cancelled.progressValue"/>
                            </b-card>
                        </b-card-group>
                    </b-col>
                </b-row>

            </slot>
        </Request>

    </div>
</template>

<script>
    import Request from '../../components/Request'
    import CardList from '../../components/CardList'
    import CardChartLineSmall from '../../components/CardChartLineSmall'
    import DynamicCardList from '../../components/DynamicCardList'
    import { HotTable } from '@handsontable/vue';
    export default {
        name: 'dashboard',
        components: {
            Request,
            CardList,
            CardChartLineSmall,
            DynamicCardList,
            HotTable
        },
        mounted() {
            this.$refs.requestWidget.request()

            this.myData = [
                ['', '', ''],
                ['', '', '']
            ]
        },
        data: () => {
            return {
                myData: false,
                Core: window.Core,
                Mantle: window.Mantle,
                dataWidget: {
                    labels: [],
                    data: [],
                    value: 0,
                    payments: {
                        completed: {
                            labels: [],
                            data: [],
                            value: 0
                        },
                        due: {
                            value: 0,
                            progressValue: 0
                        },
                        failed: {
                            value: 0,
                            progressValue: 0
                        },
                        waiting: {
                            value: 0,
                            progressValue: 0
                        }
                    },
                    subscriptions: {
                        activated: {
                            labels: [],
                            data: [],
                            value: 0
                        },
                        renewed: {
                            value: 0,
                            progressValue: 0
                        },
                        expiration: {
                            value: 0,
                            progressValue: 0
                        },
                        completed: {
                            value: 0,
                            progressValue: 0
                        }
                    },
                    events: {
                        booking: {
                            labels: [],
                            data: [],
                            value: 0
                        },
                        present: {
                            value: 0,
                            progressValue: 0
                        },
                        absent: {
                            value: 0,
                            progressValue: 0
                        },
                        cancelled: {
                            value: 0,
                            progressValue: 0
                        }
                    }
                }
            }
        },
        methods: {
            onRequestSuccess(data) {
                if (data.payments !== undefined) {
                    this.dataWidget.payments = data.payments
                }
                if (data.subscriptions !== undefined) {
                    this.dataWidget.subscriptions = data.subscriptions
                }
                if (data.events !== undefined) {
                    this.dataWidget.events = data.events
                }
            }
        }
    }
</script>
